// Profile-name changes go through the backend, which checks who may rename an
// account and updates the profile, class memberships and Auth together.
import { auth } from "../firebaseConfig";
import { API_BASE_URL } from "./apiBase";


// Teacher-created student accounts keep the name their teacher entered.
export const canEditOwnName = (user) => user?.accountManagedByTeacher !== true;

async function postName(path, name) {
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error("Please sign in again before changing a name.");

  const token = await currentUser.getIdToken();
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.ok) {
    throw new Error(data.error || "Could not save the name. Please try again.");
  }
  return data.name;
}

export const saveOwnName = (name) => postName("/api/profile/name", name);

export const saveManagedStudentName = (studentUid, name) =>
  postName(`/api/students/${encodeURIComponent(studentUid)}/name`, name);
